import React from "react";
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  root: {
    fontSize: "1rem",
  },
  card: {
    backgroundColor: () => "#fff",
    borderRadius: () => "1.25rem",
    margin: () =>  "0 0 1rem 0",
  },
}));

export default function WhiteCard({ children, ...rest }) {
  const classes = useStyles(rest);
  return <div className={classes.card}>{children}</div>;
}
